/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { createContext, Fragment, type ReactNode } from "react";
import { cssFns } from "@superweb/css";
import { useUiColors } from "../theme";
import { useTypo } from "../typo";
import React from "react";
import { useId } from "react-aria";

export const ExperimentalListViewContext = createContext<boolean | undefined>(
  undefined,
);

const ExperimentalListViewProvider = ExperimentalListViewContext.Provider;

export const ExperimentalListView = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  const uiColors = useUiColors();
  const typo = useTypo();
  const titleId = useId();

  return (
    <ExperimentalListViewProvider value={true}>
      <div
        role="group"
        aria-labelledby={titleId}
        css={{
          display: "flex",
          flexDirection: "column",
          ...cssFns.padding("0", "24px"),
          ...cssFns.border({
            radius: "24px",
            width: "0px",
          }),
          backgroundColor: uiColors.background,
        }}
      >
        <div
          id={titleId}
          css={{
            width: "100%",
            height: "56px",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            ...typo({
              level: "body1",
              weight: "medium",
              density: "tight",
            }),
          }}
        >
          {title}
        </div>
        <div>
          {React.Children.map(children, (child, index) => (
            <Fragment key={index}>
              {index !== 0 ? (
                <div
                  css={{ height: "0.5px", backgroundColor: uiColors.line }}
                />
              ) : undefined}
              {child}
            </Fragment>
          ))}
        </div>
      </div>
    </ExperimentalListViewProvider>
  );
};
